<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Vehicle Repair BreakDown Details">
        <v-card-actions>
          <router-link :to="{ name: 'addVehicleRepairBreakdown', params: {} }" title="Add Vehicle RepairBreakDown Details">
            <v-btn small style="position: absolute;right: 130px;top: 20px;" elevation="1" color="primary">
              <v-icon left>mdi-plus</v-icon>
              Add Vehicle Repair BreakDown
            </v-btn>
          </router-link>
          <!-- <a @click="$router.back()"> -->
            <router-link :to="{ name: 'vehicleSetting', params: {} }" title="Vehicle Settings">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            </router-link>
          <!-- </a> -->
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="Save">
            <v-row>
              <v-col cols="12" md="6" lg="5">
                <label class="font-weight-medium body-2">Select Vehicle Number <span class="error--text">*</span></label>
                <v-autocomplete
                  class="my-0 py-1"
                  prepend-icon="mdi-account"
                  :items="vehicleDetails"
                  key="id"
                  item-text="vehicleRegistrationNumber"
                  item-value="id"
                  v-model="VehicleId"
                  single-line
                  required
                  placeholder="--Select--"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">Filter Action</label>

                <div class="inside">
                  <v-btn class="mr-4" color="success" elevation="1" type="submit">
                    <v-icon left> mdi-text-box-check-outline </v-icon>
                    Apply</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="vehicleRepairBreakDownDetails"
            :search="search"
          >
            <template v-slot:item.vehicleDetails="{ item }">
              {{ item.vehicleDetails[0].vehicleRegistrationNumber || '-' }}
            </template>
            <template v-slot:item.repairType="{ item }">
              {{ item.repairType || '-' }}
            </template>
            <template v-slot:item.meterReadingAtRepairTime="{ item }">
              {{ item.meterReadingAtRepairTime || '-' }}
            </template>
            <template v-slot:item.repairCost="{ item }">
              {{ item.repairCost || '-' }}
            </template>
            <template v-slot:item.repairDate="{ item }">
              {{ new Date(item.repairDate).toLocaleDateString() }}
            </template>
            <template v-slot:item.billNo="{ item }">
              {{ item.billNo || '-' }}
            </template>
            <template v-slot:item.billDate="{ item }">
              {{ new Date(item.billDate).toLocaleDateString() != 'Invalid Date' ? new Date(item.billDate).toLocaleDateString() : '-' }}
            </template>
            <template v-slot:item.billApprovedBy="{ item }">
              {{ item.billApprovedBy || '-' }}
            </template>
            <template v-slot:item.repairApprovedBy="{ item }">
              {{ item.repairApprovedBy || '-' }}
            </template>
            <template v-slot:item.remark="{ item }">
              {{ item.remark || '-' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn x-small class="px-2 ml-1 ma-1" color="red" outlined @click.prevent="viewDocuments(item.id)">
                View Docs
              </v-btn>
              <router-link :to="{ name: 'editvehicleRepairBreakdown', params: { repairID: item.id } }">
                <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                  <v-icon small> mdi-pencil</v-icon>
                </v-btn>
              </router-link>
              <!-- <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="(item.deletedAt = 'null')" @click.prevent="statusChange(item.id)">
                <v-icon small > mdi-trash-can</v-icon>
              </v-btn> -->
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
    <div class="modal" :class="{ 'is-active': enableDocumentModal }">
      <div class="modal-background"></div>
      <form class="modal-card" @submit.prevent="ShowDocuments()">
        <header class="modal-card-head" style="margin-top:90px;">
          <p class="modal-card-title"><strong>View Documents</strong></p>
          <button class="delete" type="button" @click="this.toggleDocumentModal"></button>
        </header>
        <v-data-table
          :footer-props="{
            'items-per-page-options': [5]
          }"
          :items-per-page="10"
          :headers="docsheaders"
          :items="vehicleRepairBreakDownDocuments"
          :search="search"
        >
          <template v-slot:item.Vehicle_Documents="{ item }">
            <v-btn x-small class="px-2 ml-1 ma-1" color="red" outlined @click.prevent="downloadDocuments(item.urlPath)">
              {{ item.documentType || '-' }}
            </v-btn>
          </template>
        </v-data-table>
      </form>
    </div>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'vehicleRepairBreakdown',
  components: {
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      search: '',
      isLoading: false,
      loadingComponent: null,
      academicYears: [],
      academicYearID: '',
      stages: [],
      inProgress: false,
      franchiseeArr: [],
      vehicleRepairBreakDownDetails: [],
      vehicleRepairBreakDownDocuments: [],
      franchiseeID: '',
      enableDocumentModal: false,
      vehicleDetails: [],
      VehicleId: '',
      announcments: [],
      abg: 'i am swapnil',
      total: '',
      headers: [
        { text: 'Vehicle Number', value: 'vehicleDetails', sortable: true },
        { text: 'Repair Type', value: 'repairType', sortable: true },
        { text: 'Start Reading', value: 'meterReadingAtRepairTime', sortable: true },
        { text: 'Repair Cost', value: 'repairCost', sortable: true },
        { text: 'Date', value: 'repairDate', sortable: true },
        { text: 'Bill No', value: 'billNo', sortable: true },
        { text: 'Bill Date', value: 'billDate', sortable: true },
        { text: 'Bill Approved By', value: 'billApprovedBy', sortable: true },
        { text: 'Repair Approved By', value: 'repairApprovedBy', sortable: true },
        { text: 'Remark', value: 'remark', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ],
      docsheaders: [{ text: 'Vehicle Repair BreakDown Documents', value: 'Vehicle_Documents', sortable: true }]
    }
  },
  async created () {
    await this.getYear()
    await this.getFranchiseeList()
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        await this.getVehicleList()
        this.inProgress = false
      }
    },
    toggleDocumentModal: function () {
      this.enableDocumentModal = !this.enableDocumentModal
    },
    viewDocuments: async function (ID) {
      this.toggleDocumentModal()
      let response = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclerepairbreakdowndetails/document/${ID}`)
      this.vehicleRepairBreakDownDocuments = response.data
    },
    getVehicleList: async function () {
      try {
        this.isLoading = true
        let getParam = {}
        if (this.franchiseeID.length === 0) {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          getParam.franchiseeID = this.franchiseeID
        }
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails`, {
          params: getParam
        })
        this.vehicleDetails = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    downloadDocuments: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    Save: async function () {
      this.vehicleRepairBreakDownDetails = []
      this.total = ''
      try {
        let getParam = {}
        getParam.vehicleID = this.VehicleId
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclerepairbreakdowndetails`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleRepairBreakDownDetails = data
          this.vehicleRepairBreakDownDetails.forEach(element => {
            element.billDate = moment(element.billDate, 'YYYY-MM-DD').format('LL')
          })
          this.total = this.vehicleRepairBreakDownDetails.length
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    }
  }
}
</script>
